export default __webpack_public_path__ + "static/media/next.d276e45b.svg";